
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { PageHeadline } from '@/components/atom/PageHeadline';
import { MarketCard } from '@/components/exchange/MarketCard';
import { MAINNET } from '@/constants/env';
import { useTranslation } from '@/hooks/support/translate';
import { marketOrdersAtom } from '@/state/app';
import styles from '@/styles/Global.module.css';
import { getExchangeOrders } from '@/utils/http/get-exchange-orders';
import classNames from 'classnames';
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useExchangeBalance } from '@/hooks/exchange/balance';
import { walletAtom } from '@/state/wallet';
import { ExchangeOrder } from '@/constants/types';
import { useEvent } from 'react-use';
import { usePolling } from '@/hooks/polling';
import { arrayToObject, sortByKey } from '@/utils/common';
import { formatAPIOrders, useMarketOrders } from '@/hooks/exchange/orders';
import WhitelistModal from '@/components/game/WhitelistModal';
/*
TODO
    TESTNET SET-UP
    - Protect with Whitelist sections
    - Ensure feature/version separation Mainnet
    ALPHA-SET-UP
    - Unbonding time calculation
    - APY calculation
    - Update and test contracts
    - Claim time estimation
 */

const Market = (props: InferGetStaticPropsType<typeof getStaticProps>) => {
    const [isScreenVisible, setIsScreenVisible] = useState(false);
    useExchangeBalance();
    useMarketOrders();
    usePolling(isScreenVisible);
    const { t } = useTranslation();
    const setMarketOrdersData = useSetRecoilState(marketOrdersAtom);
    const walletState = useRecoilValue(walletAtom);
    const testnetTitle = !MAINNET ? `${t('common.testnet')} ` : '';
    const title = `ClayStack ${testnetTitle}| ${t('common.title')}`;

    useEffect(() => {
        const orders = arrayToObject(formatAPIOrders(props.orders), '_id');
        setMarketOrdersData({
            orders,
            updateAPI: new Date().getTime(),
            update: new Date().getTime(),
        });
    }, [props.orders]);

    // Set Focus on page for Polling hook
    const handlePageVisibility = async () => {
        const isVisible = document.hasFocus();
        setIsScreenVisible(isVisible);
    };
    useEvent('visibilitychange', handlePageVisibility);

    return (
        <>
            <Head>
                <title>{title}</title>
            </Head>
            <div className={styles.page}>
                <div
                    className={classNames(
                        'flex flex-col items-center justify-center w-full px-4 pt-12 my-auto xl:px-0',
                    )}
                >
                    <div className="fixed top-0 z-[-1] market-gradient blur-2xl"></div>
                    <PageHeadline
                        title={'Marketplace'}
                        caption={'Exchange your liquid tokens for native tokens in marketplace'}
                        align="center"
                    />
                    <WhitelistModal>
                        <div className="flex flex-col items-start w-full px-8">
                            <MarketCard />
                        </div>
                    </WhitelistModal>
                </div>
            </div>
        </>
    );
};

type SerializedMarketOrders = { orders: ExchangeOrder[] };

 const _getStaticProps: GetStaticProps<SerializedMarketOrders> = async () => {
    const results = await getExchangeOrders({}, false);
    return {
        props: { orders: sortByKey(results, '_id', true) },
        revalidate: 60, //60 * 60, // TODO determine optimal
    };
};

export default Market;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/market',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  